export const areCoordinatesEqual = ({ lat, lng }, { lat: lat2, lng: lng2 }) =>
  lat === lat2 && lng === lng2;
